module.exports = ".error {\n  color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/nat-rep-settings/nat-rep-settings.component.css
// module id = ./src/app/components/nat-rep-settings/nat-rep-settings.component.css
// module chunks = main